<main>
  <ui-chat-bot-sa-element
    *ngIf="chatFlow && funnelLanguage"
    [flowDesign]="chatFlow.design"
    [chatFlow]="chatFlow"
    [testMode]="false"
    [funnelLanguage]="funnelLanguage"
  ></ui-chat-bot-sa-element>

  <ng-container *ngIf="errorFunnelStatus">
    <div class="error-container-wrapper">
      <div class="error-box">
        <img
          [src]="errorIconUrl"
          alt=""
          aria-hidden="true"
          width="120"
          height="120"
        />

        <h1 class="h1-error-title">
          {{
            errorFunnelStatus === 'funnel_not_published'
              ? ('error_funnel_not_published' | translate)
              : ('error_funnel_not_found' | translate)
          }}
        </h1>
        <div *ngIf="errorFunnelStatus === 'funnel_not_published'">
          {{ 'error_funnel_come_back_later' | translate }}
        </div>
      </div>
    </div>
  </ng-container>
</main>

<footer
  *ngIf="!chatFlow?.design?.white_labeling"
  role="contentinfo"
  style="position: relative"
>
  <powered-by-hypt [funnelLanguage]="funnelLanguage"></powered-by-hypt>
</footer>
